import { useEffect, useState } from "react";
import { useParams, useNavigate, Navigate } from "react-router-dom";
import { Eye, ArrowLeft, Pencil } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import ArticleView from "@/components/public/ArticleView";

const STATUS_LABELS = { draft: "Borrador", scheduled: "Programado", published: "Publicado", archived: "Archivado" };

export default function ArticlePreview() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { loading, user } = useAuth();
  const [article, setArticle] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    if (loading || !user) return;
    api.get(`/admin/articles/${id}/preview`)
      .then((r) => setArticle(r.data))
      .catch((err) => setError(formatApiError(err.response?.data?.detail)));
  }, [id, loading, user]);

  if (loading) return <div className="pt-40 text-center min-h-screen text-sunset-muted">Cargando…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  if (error) return (
    <div className="pt-40 text-center min-h-screen">
      <h1 className="font-serif text-4xl mb-4">{error}</h1>
      <button onClick={() => navigate("/admin/articulos")} className="kicker text-sunset-accent">Volver</button>
    </div>
  );
  if (!article) return <div className="pt-40 text-center min-h-screen text-sunset-muted">Cargando…</div>;

  return (
    <div className="bg-sunset-bg min-h-screen" data-testid="article-preview">
      <div className="sticky top-0 z-[300] bg-sunset-accent text-white px-5 py-3 flex items-center justify-between flex-wrap gap-3">
        <div className="flex items-center gap-3">
          <Eye size={18} />
          <span className="kicker text-white">Vista previa · {STATUS_LABELS[article.status] || article.status}</span>
        </div>
        <div className="flex items-center gap-3">
          <button onClick={() => navigate(`/admin/articulos/${id}`)} data-testid="preview-edit-btn"
            className="flex items-center gap-2 text-xs uppercase tracking-wider bg-white/15 hover:bg-white/25 px-4 py-2 transition-colors">
            <Pencil size={14} /> Editar
          </button>
          <button onClick={() => navigate("/admin/articulos")}
            className="flex items-center gap-2 text-xs uppercase tracking-wider bg-white text-sunset-accent px-4 py-2 hover:bg-sunset-ink hover:text-white transition-colors">
            <ArrowLeft size={14} /> Volver al panel
          </button>
        </div>
      </div>
      <ArticleView article={article} preview ads={false} />
    </div>
  );
}
